import React, {Component} from 'react';
import {Tab, Tabs, TabList, TabPanel} from 'react-tabs';
import {Editor} from '../editor-components';
import ExpoList from '../expo-list/expo-list';
import UserList from '../user-list/user-list';
import AffiliateList from '../affiliate-list/affiliate-list';
import ExhibitorList from '../exhibitor-list/exhibitor-list';

export default class AdminDashboard extends Component {

  render() {
    return (
      <Editor>
        <Tabs>
          <TabList>
            <Tab>Expos</Tab>
            <Tab>Users</Tab>
            <Tab>Affiliates</Tab>
            <Tab>Exhibitors</Tab>
          </TabList>
          <TabPanel>
            <ExpoList/>
          </TabPanel>
          <TabPanel>
            <UserList/>
          </TabPanel>
          <TabPanel>
            <AffiliateList/>
          </TabPanel>
          <TabPanel>
            <ExhibitorList/>
          </TabPanel>
        </Tabs>
      </Editor>
    )

  }
}



// WEBPACK FOOTER //
// ./src/dashboard/admin-dashboard.js